/**
 * Select a Job
 */
import {Select} from '@wandb/weave/components/Form/Select';
import React from 'react';
import {SingleValue} from 'react-select';

import * as S from '../SelectComponents.styles';
import {TemplateVariableType} from './defaultResourceConfigUtil';

interface SelectVariableTypeProps {
  selectedType: VariableTypeOption | undefined;
  onSelectVariableType: (job: SingleValue<VariableTypeOption>) => void;
}

export type JobInfo = {
  jobName: string;
  jobVersion: string;
  jobProject?: string;
};

export interface VariableTypeOption {
  value: TemplateVariableType;
  label: string;
}

const OptionLabel = (props: VariableTypeOption) => {
  return (
    <S.SelectOptionLabel>
      <S.SelectOptionLabelText>{props.label}</S.SelectOptionLabelText>
    </S.SelectOptionLabel>
  );
};

const TYPE_OPTIONS: readonly VariableTypeOption[] = [
  {value: 'integer', label: 'Integer'},
  {value: 'string', label: 'String'},
  {value: 'number', label: 'Float'},
] as const;

export const SelectVariableType = ({
  selectedType,
  onSelectVariableType,
}: SelectVariableTypeProps) => {
  return (
    <Select
      options={TYPE_OPTIONS}
      placeholder="Select a type..."
      defaultValue={selectedType}
      formatOptionLabel={OptionLabel}
      onChange={onSelectVariableType}
    />
  );
};
